var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      class: _vm.question.getItemClass(_vm.row, _vm.column),
      on: {
        mousedown: function ($event) {
          return _vm.question.onMouseDown()
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.row.value,
            expression: "row.value",
          },
        ],
        class: _vm.question.cssClasses.itemValue,
        attrs: {
          type: "radio",
          name: _vm.row.fullName,
          readonly: _vm.row.isReadOnlyAttr,
          disabled: _vm.row.isDisabledAttr,
          id: _vm.question.inputId + "_" + _vm.row.name + "_" + _vm.columnIndex,
          "aria-required": _vm.question.a11y_input_ariaRequired,
          "aria-label": _vm.question.getCellAriaLabel(
            _vm.row.locText.renderedHtml,
            _vm.column.locText.renderedHtml
          ),
          "aria-invalid": _vm.question.a11y_input_ariaInvalid,
          "aria-errormessage": _vm.question.a11y_input_ariaErrormessage,
        },
        domProps: {
          value: _vm.column.value,
          checked: _vm._q(_vm.row.value, _vm.column.value),
        },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.row, "value", _vm.column.value)
          },
        },
      }),
      _vm._v(" "),
      _c("span", { class: _vm.question.cssClasses.materialDecorator }, [
        _vm.question.itemSvgIcon
          ? _c("svg", { class: _vm.question.cssClasses.itemDecorator }, [
              _c("use", { attrs: { "xlink:href": _vm.question.itemSvgIcon } }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.question.isMobile
        ? _c(
            "span",
            { class: _vm.question.cssClasses.cellResponsiveTitle },
            [_c("survey-string", { attrs: { locString: _vm.column.locText } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }